module.exports = __webpack_public_path__ + "img/13.d192f56b.png";